/**
 * Do not edit directly, use `yarn generate:icons`
 */

import React from 'react';
import {Base} from '../../../Internal/Base';

const pathStrings = {
  16: [
    'M8 .667a7.333 7.333 0 1 1 0 14.666A7.333 7.333 0 0 1 8 .667M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2m.667 4.667V12H7.333V6.667zm-.667-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2',
  ],

  24: [
    'M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 2a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3m1 7v8h-2v-8zm-1-4.5a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 12 5.5',
  ],
};

type Props = {size: keyof typeof pathStrings} & Omit<
  React.SVGAttributes<HTMLOrSVGElement>,
  'width' | 'height' | 'viewBox'
>;

export const IconInfoOutline = ({
  size,
  className,
  ...rest
}: Props): React.ReactElement<React.ReactSVGElement> => {
  const paths = pathStrings[size].map((d: string, i: number) => (
    <path key={String(i)} d={d} fillRule="evenodd" />
  ));

  return (
    <Base
      as="svg"
      height={size}
      width={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      // Because viewPort(height + width) and viewBox might not have the same ratio
      // `preserveAspectRatio` indicates wether we should force a uniform scaling.
      // Therefore, `xMidYMid` centers the viewBox region within the viewPort region,
      // and `meet` scales the graphic until it meets the height and width of our viewPort.
      // More details here, https://www.digitalocean.com/community/tutorials/svg-preserve-aspect-ratio
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      {...rest}
    >
      {paths}
    </Base>
  );
};

IconInfoOutline.displayName = 'IconInfoOutline';
